import { ResourceType } from "frontend/canvas-designer-new/monday-import-items/monday-import-items.types";
import styles from "./resource-item.module.css";
import cn from "classnames";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { useRef } from "react";
import { useIsTextOverflowing } from "frontend/hooks/use-is-text-overflowing";

export const ResourceItem = ({
  resource,
  variant,
  showIcon = true,
  type,
  disabled = false,
  disabledTooltip,
}: {
  resource?: ResourceType;
  variant: "header" | "option";
  showIcon?: boolean;
  type: "workspace" | "board";
  disabled?: boolean;
  disabledTooltip?: string;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const nameRef = useRef<HTMLDivElement>(null);
  const containerHover = useHover(containerRef);
  const isOverflowing = useIsTextOverflowing(nameRef);

  if (!resource) return null;

  const tooltipLabel = (() => {
    if (!containerHover) return false;

    if (disabled && disabledTooltip) {
      return disabledTooltip;
    }
    if (isOverflowing) {
      return resource.name;
    }
    return null;
  })();

  return (
    <div
      className={cn(styles.resourceItem, styles[`variant-${variant}`], { [styles.disabled]: disabled })}
      ref={containerRef}
    >
      {type === "workspace" && showIcon && (
        <div className={cn(styles.resourceItemIcon, styles[`variant-${variant}`])}>
          {resource?.image ? (
            <div className={styles.resourceItemIconImage} style={{ backgroundImage: `url(${resource.image})` }} />
          ) : (
            <div
              className={styles.resourceItemIconColor}
              style={{ "--color": resource.color } as React.CSSProperties}
              data-has-color={!!resource.color}
            >
              {resource?.name?.charAt(0)?.toUpperCase()}
            </div>
          )}
        </div>
      )}
      {type === "board" && variant === "header" && (
        <div className={styles.resourceItemBoardIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" fill="none" viewBox="0 0 15 12">
            <path stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" d="M4.459.5v10.625"></path>
            <rect width="13.25" height="11" x="0.5" y="0.5" stroke="#1E1E1E" rx="1.5"></rect>
          </svg>
        </div>
      )}
      <div className={styles.resourceItemName} ref={nameRef}>
        {resource.name}
      </div>

      {!!tooltipLabel && (
        <Tooltip
          label={tooltipLabel}
          relativeTo={containerRef}
          design="monday"
          side="right"
          customStyle={{ borderRadius: 3 }}
        />
      )}
    </div>
  );
};
